<template>
  <div class="mtx-toggle" :class="{ 'mtx-toggle--open': isOpen }">
    <button
      ref="label"
      :disabled="disabled"
      :id="`mtx-toggle-${id}-label`"
      :aria-controls="`mtx-toggle-${id}-content`"
      :aria-expanded="isOpen"
      @click="setOpen(!isOpen)"
      class="btn--block btn--link mtx-toggle__button"
    >
      <h5 class="mtx-toggle__label flex align-center justify-between px-2 py-2" tabindex="-1">
        <span v-html="label" class="mr-1"></span>
        <MtxSvg class="mtx-toggle__icon" icon="icon-chevron-down" />
      </h5>
    </button>

    <transition
      @before-enter="collapse"
      @enter="expand"
      @after-enter="resetHeight"
      @before-leave="expand"
      @leave="collapse"
    >
      <div
        :id="`mtx-toggle-${id}-content`"
        :aria-labelledby="`mtx-toggle-${id}-label`"
        :aria-hidden="!isOpen"
        v-show="isOpen && !disabled"
        role="region"
        class="mtx-toggle__content"
      >
        <div class="px-2 py-2">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },

    disabled: Boolean,
    startOpen: Boolean
  },

  data: () => ({
    isOpen: false
  }),

  computed: {
    id() {
      if (this.$attrs.id) return this.$attrs.id

      return Array(6)
        .fill()
        .map(() => Math.floor(36 * Math.random()).toString(36))
        .join("")
    }
  },

  mounted() {
    this.isOpen = this.startOpen
  },

  methods: {
    collapse(el) {
      el.style.height = "0"
    },

    expand(el) {
      el.style.height = el.scrollHeight + "px"

      // only works with this prop accessed again
      el.scrollHeight
      // (╯°□°）╯︵ ┻━┻
    },

    resetHeight(el) {
      el.style.height = ""
    },

    setOpen(isOpen) {
      this.isOpen = isOpen
    }
  }
}
</script>

<style lang="scss">
.mtx-toggle {
  overflow: hidden;
  border: 1px solid $stroke;
  border-radius: $borderRadius;

  &__button:not(:disabled) &__label {
    color: #fff;
    background: var(--highlight);
  }

  &__label:focus {
    outline: 0;
  }

  &__icon {
    transition: transform 300ms ease;
  }

  &--open &__icon {
    transform: scaleY(-1);
  }

  &__content {
    border-top: 1px solid $stroke;
    overflow: hidden;

    transition: height 300ms ease;
  }
}
</style>
